import { render } from "./VipRecharge.vue?vue&type=template&id=c725aafc&scoped=true"
import script from "./VipRecharge.vue?vue&type=script&lang=js"
export * from "./VipRecharge.vue?vue&type=script&lang=js"

import "./VipRecharge.vue?vue&type=style&index=0&id=c725aafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c725aafc"]])

export default __exports__